import { Icon, Stack } from '@mui/material';

export default function IconThumbnail({ iconName }) {
    return (
        <Stack
            justifyContent="center"
            alignItems="center"
            direction="row"
            sx={{
                backgroundColor: 'success.secondary',
                position: 'relative',
                alignItems: 'center',
                height: 1,
                width: 1
            }}
        >
            <Icon
                sx={{
                    color: 'success.main',
                    fontSize: theme => theme.typography.pxToRem(48)
                }}
            >
                {iconName}
            </Icon>
        </Stack>
    );
}
